import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="w-full border-b border-line bg-ink px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="testimonios-title" data-id="element-235" data-mp="1mzsai10nhef7">
      <div className="mx-auto max-w-5xl" data-id="element-236" data-mp="1d24df4fknutv">
        <SectionHeading eyebrow="❤️" title="Más atletas que ya lo tienen" data-id="element-237" data-mp="1d1300tb32w8z" />

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-238" data-mp="1i17j8r3dm52w">
          {testimonials.map((item, index) => <motion.li key={item.initials} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="rounded-2xl border border-line bg-surface p-6" data-id="element-239" data-mp="1427vdlnotu7s" data-mpi={index}>
              <figure data-id="element-240" data-mp="2v1kqmkvmm3u6">
                <div className="flex items-start gap-3" data-id="element-241" data-mp="2v0svtc9usa4y">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gold/15 text-sm font-extrabold text-gold" data-id="element-242" data-mp="2uz80hkfpsn61">
                    {item.initials}
                  </span>
                  <div className="min-w-0" data-id="element-243" data-mp="34t8gihcjbctj">
                    <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-244" data-mp="2ztca6bgd79at">
                      {Array.from({
                    length: 5
                  }).map((_, starIndex) => <StarIcon key={starIndex} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-245" data-mp="2756ptpt83mbi" data-mpi={starIndex} />)}
                    </div>
                    <figcaption className="mt-1 text-sm font-bold text-white" data-id="element-246" data-mp="19vurfjwrdyj">
                      {item.name}
                    </figcaption>
                    <p className="mt-0.5 flex flex-wrap items-center gap-1.5 text-xs text-neutral-500" data-id="element-247" data-mp="3sj2pgntqgh8i">
                      <MapPinIcon className="h-3 w-3" aria-hidden="true" data-id="element-248" data-mp="3gv9ki658us4" />
                      {item.location}
                      {item.tag ? <span data-id="element-249" data-mp="dd80576e6sin">| {item.tag}</span> : null}
                    </p>
                  </div>
                </div>
                <blockquote className="mt-4 text-sm leading-relaxed text-neutral-300" data-id="element-250" data-mp="icb6cuy3z4s7">
                  “{item.quote}”
                </blockquote>
              </figure>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}